import { render } from "./dialogAyudaArchivarOficios.vue?vue&type=template&id=1e9f56dc&scoped=true"
import script from "./dialogAyudaArchivarOficios.vue?vue&type=script&lang=js"
export * from "./dialogAyudaArchivarOficios.vue?vue&type=script&lang=js"

import "./dialogAyudaArchivarOficios.vue?vue&type=style&index=0&id=1e9f56dc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9f56dc"]])

export default __exports__